// The CDN host is resolved at request time rather than baked in, so one built artifact serves every stage.
// The three emitters (transformAssets, Vite's renderBuiltUrl, assetUrl) must agree byte-for-byte or SSR and
// the client's first render disagree. See https://vite.dev/guide/build.html#advanced-base-options

declare global {
  interface Window {
    __CDN_URL?: string
  }
}

/** The CDN origin for this deployment, or '' when assets are same-origin (dev / e2e). No trailing slash. */
export function getRuntimeCdnUrl(): string {
  if (typeof window !== 'undefined') return (window.__CDN_URL ?? '').replace(/\/$/, '')
  // SSR: same-origin in dev (Vite serves assets) and in the e2e build (unified server hosts them).
  if (import.meta.env.DEV) return ''
  if (typeof process !== 'undefined') {
    if (process.env.E2E_PGLITE === 'true') return ''
    return (process.env.URL_CDN ?? '').replace(/\/$/, '')
  }
  return ''
}

// Mirror of the globalThis.__assetUrl injected in __root — keep the two in lockstep.
export function assetUrl(file: string): string {
  const base = getRuntimeCdnUrl()
  return (base ? `${base}/` : '/') + file.replace(/^\//, '')
}
